import { getAktiveOpslagDatasource } from '@/data/opslag';
import { getAppConfig } from '@/letapps-vue/utils/appConfig';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useOpslagListeStore = (uniqueStoreName, opslagType, maalgruppeId) => {
  let store = defineStore(uniqueStoreName, () => {
    const pagesize = 10;

    const opslagDatasource = getAktiveOpslagDatasource();
    const opslagDatasourceStore = opslagDatasource.store();

    const opslagListe = ref([]);
    const loading = ref(false);
    const flere = ref(true);
    const skip = ref(0);
    const lastScrollPosition = ref(0);

    async function opdater() {
      loading.value = true;
      opslagDatasourceStore.userData.rolleId = getAppConfig().lederMaalgruppeId;
      opslagDatasourceStore.userData.leder = !!maalgruppeId;
      const loadResult = await opslagDatasourceStore.load({
        take: pagesize,
        skip: skip.value,
        filter: [['opslagType', '=', opslagType]],
        sort: [
          { selector: 'altidOeverst', desc: true },
          { selector: 'publiceringsTidspunkt', desc: true },
        ],
      });
      loading.value = false;

      let filteredList = loadResult.data;

      if (maalgruppeId) {
        filteredList = filteredList.filter((x) =>
          x.adgange.some((a) => a.rolle?.id === maalgruppeId),
        );
      } else {
        filteredList = filteredList.filter((x) => x.adgange.length === 0);
      }

      opslagListe.value.push(...filteredList);
      if (filteredList.length === 0) {
        flere.value = false;
      }
    }

    function visFlere() {
      skip.value = skip.value + pagesize;
      opdater(opslagType, maalgruppeId);
    }

    function updateScrollPosition(value) {
      lastScrollPosition.value = value;
    }

    opdater();

    return {
      opslagListe,
      loading,
      flere,
      skip,
      lastScrollPosition,
      opdater,
      visFlere,
      updateScrollPosition,
    };
  });
  return new store();
};
